import Container from '../../components/Layout/Container';
import common from './Common.module.scss';
import local from './SectionBreak.module.scss';
import avatarImg from '../../assets/images/break2-avatar.svg';
import { Alert, Button } from 'antd';
import { useSurveyContext } from '../../context/SurveyContext';
import { useSurveySubmit } from './useSurveySubmit';

const Section2Break = () => {
  const { surveyState, setCurrentStep, setCurrentSection, setCurrentSubsection } = useSurveyContext();
  const { submit, isSubmitting, error } = useSurveySubmit();

  const handleContinue = () => {
    // Move to section 3, starting from subsection 0
    setCurrentSection(2);
    setCurrentSubsection(0);
    setCurrentStep('section-3');
  };

  // Sections 1 and 2 are the only keys present at this point, which is exactly
  // what the backend expects for a stop after Section 2.
  const handleStop = () => {
    submit(surveyState.answers);
  };

  return (
    <div className={`${common.surveyWrapper} ${local.breakWrapper}`}>
      <Container>
        <div className={common.surveyAvatarWrapper}>
          <img src={avatarImg} alt="Section 2 Break Avatar" className={common.surveyAvatar} />
        </div>
        <div className={common.surveyTextSection}>
          <h1 className={common.surveyTitle}>You’ve just gained insight into your inner world</h1>
          <div className={local.breakParagraphs}>
            <p>Understanding your personality and inner motivations brings you closer to clarity.</p>
            <p>Next up is Section 3, where you’ll explore career paths aligned with who you truly are. If you’ve ever felt unsure about what direction to take in life, this part can help connect the dots.</p>
            <p>It’s optional but can be incredibly eye-opening.</p>
          </div>
          {error && (
            <div className={local.breakError}>
              <Alert type="error" message={error} showIcon />
            </div>
          )}
          <div className={local.breakButtonRow}>
            <Button
              className={local.breakSecondaryButton}
              onClick={handleStop}
              loading={isSubmitting}
            >
              Send Report to Email
            </Button>
            <Button
              type="primary"
              className={local.breakPrimaryButton}
              onClick={handleContinue}
              disabled={isSubmitting}
            >
              Continue
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Section2Break;
